<div class="profile-tab">
  <div class="row">
    <!-- Left Column -->
    <div class="col-md-6">
      <div class="form-group">
        <label class="col-md-6 control-label" for="unitNumber">UNIT NUMBER</label>
        <div class="col-md-6 inputSpace">
          <input
            id="unitNumber"
            name="unitNumber"
            type="text"
            class="form-control"
            [(ngModel)]="tractor.unitNumber"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="peopleNetStatus">PEOPLENET STATUS</label>
        <div class="col-md-6 inputSpace">
          <span class="status-pill status-sleeper-berth">
            {{ getPeopleNetStatus() }}
          </span>
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="tractorStatus">TRACTOR STATUS</label>
        <div class="col-md-6 inputSpace">
          <select
            id="tractorStatus"
            name="tractorStatus"
            class="form-control"
            [(ngModel)]="tractor.status"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          >
            <option *ngFor="let option of tractorStatusOptions" [ngValue]="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="assignedDriver">ASSIGNED DRIVER</label>
        <div class="col-md-6 inputSpace">
          <select
            id="assignedDriver"
            name="assignedDriver"
            class="form-control"
            [(ngModel)]="tractor.driverId"
            (ngModelChange)="onDriverChange()"
            [disabled]="!isEditMode"
          >
            <option [ngValue]="null">--Select Driver--</option>
            <option *ngFor="let driver of drivers" [ngValue]="driver.id">
              {{ driver.itemName || (driver.lastName + ', ' + driver.name) }}
            </option>
          </select>
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="year">YEAR</label>
        <div class="col-md-6 inputSpace">
          <input
            id="year"
            name="year"
            type="text"
            class="form-control"
            [(ngModel)]="tractor.year"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="make">MAKE</label>
        <div class="col-md-6 inputSpace">
          <input
            id="make"
            name="make"
            type="text"
            class="form-control"
            [(ngModel)]="tractor.make"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="model">MODEL</label>
        <div class="col-md-6 inputSpace">
          <input
            id="model"
            name="model"
            type="text"
            class="form-control"
            [(ngModel)]="tractor.model"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="owner">OWNER</label>
        <div class="col-md-6 inputSpace">
          <input
            id="owner"
            name="owner"
            type="text"
            class="form-control"
            [(ngModel)]="tractor.owner"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="mobileDeviceType">MOBILE DEVICE TYPE</label>
        <div class="col-md-6 inputSpace">
          <select
            id="mobileDeviceType"
            name="mobileDeviceType"
            class="form-control"
            [(ngModel)]="tractor.mobileDeviceType"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          >
            <option value="PHONE">PHONE</option>
            <option value="TABLET">TABLET</option>
            <option value="NONE">NONE</option>
          </select>
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="mobileDeviceNumber">MOBILE DEVICE NUMBER</label>
        <div class="col-md-6 inputSpace">
          <input
            id="mobileDeviceNumber"
            name="mobileDeviceNumber"
            type="text"
            class="form-control"
            [(ngModel)]="tractor.mobileDeviceNumber"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="vinNo">VIN NUMBER</label>
        <div class="col-md-6 inputSpace">
          <input
            id="vinNo"
            name="vinNo"
            type="text"
            class="form-control"
            [(ngModel)]="tractor.vinNo"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>
    </div>

    <!-- Right Column -->
    <div class="col-md-6">
      <div class="form-group">
        <label class="col-md-6 control-label" for="terminalLocation">TERMINAL LOCATION</label>
        <div class="col-md-6 inputSpace">
          <select
            id="terminalLocation"
            name="terminalLocation"
            class="form-control"
            [(ngModel)]="tractor.terminalLocation"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          >
            <option value="">--Select Terminal--</option>
            <option *ngFor="let terminal of terminals" [ngValue]="terminal">
              {{ terminal }}
            </option>
          </select>
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="datePurchased">DATE PURCHASED</label>
        <div class="col-md-6 inputSpace">
          <input
            id="datePurchased"
            name="datePurchased"
            type="text"
            class="form-control"
            [inputMask]="dateInputMask"
            placeholder="mm/dd/yyyy"
            [(ngModel)]="tractor.datePurchased"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="purchasePrice">PURCHASE PRICE</label>
        <div class="col-md-6 inputSpace">
          <input
            id="purchasePrice"
            name="purchasePrice"
            type="text"
            class="form-control"
            [(ngModel)]="tractor.purchasePrice"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="dateSold">DATE SOLD</label>
        <div class="col-md-6 inputSpace">
          <input
            id="dateSold"
            name="dateSold"
            type="text"
            class="form-control"
            [inputMask]="dateInputMask"
            placeholder="mm/dd/yyyy"
            [(ngModel)]="tractor.dateSold"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="insuranceName">INSURANCE NAME</label>
        <div class="col-md-6 inputSpace">
          <input
            id="insuranceName"
            name="insuranceName"
            type="text"
            class="form-control"
            [(ngModel)]="tractor.insuranceName"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="insurancePolicyNumber">INSURANCE POLICY NUMBER</label>
        <div class="col-md-6 inputSpace">
          <input
            id="insurancePolicyNumber"
            name="insurancePolicyNumber"
            type="text"
            class="form-control"
            [(ngModel)]="tractor.insurancePolicyNumber"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="notes">NOTES</label>
        <div class="col-md-6 inputSpace">
          <textarea
            id="notes"
            name="notes"
            class="form-control"
            rows="3"
            [(ngModel)]="tractor.notes"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
            maxlength="1000"
          ></textarea>
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="isActive">ACTIVE</label>
        <div class="col-md-6 inputSpace">
          <p-checkbox
            id="isActive"
            name="isActive"
            [(ngModel)]="tractor.isActive"
            (ngModelChange)="onFieldChange()"
            binary="true"
            [disabled]="!isEditMode"
          ></p-checkbox>
        </div>
      </div>
    </div>
  </div>
</div>



